`<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="vx-card__title mb-12">
  <div class="my-10 text-center" v-html="$t('message.login.restoreInstructions')"></div>
  <a href="javascript: void(0)" @click="$emit('close-restore')">
    {{ $t('message.login.authForm') }}
  </a>
</div>
</template>

<script>

export default{
  data () {
    return { }
  },
  methods: {
    close () {
      this.$emit('close-restore')
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
